import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionAgePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionAge.heading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionAge.button1'),
          value: '18-24',
        },
        {
          text: t('pages.onboarding.v1.questionAge.button2'),
          value: '25-34',
        },
        {
          text: t('pages.onboarding.v1.questionAge.button3'),
          value: '35-44',
        },
        {
          text: t('pages.onboarding.v1.questionAge.button4'),
          value: '45-54',
        },
        {
          text: t('pages.onboarding.v1.questionAge.button5'),
          value: '55+',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
